<div *ngIf="isLoading" class="sdk-loading" [style]="style">
    <div *ngIf="isLoading && !showEllipsis" class="spinner">
        <div class="sdk-loading-icon"></div>
    </div>
    <div *ngIf="isLoading && showEllipsis" class="ellipsis">
        <div class="sdk-loading-icon"></div>
    </div>
</div>
